import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../ui/button/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import styles from "./Hero.module.css";

const HERO_IMAGE =
  "https://res.cloudinary.com/dcryayen2/image/upload/q_auto/f_auto/v1777314272/ChatGPT_Image_Apr_27_2026_07_22_20_PM_pzsx1t.png";

export default function Hero() {
  return (
    <section className={styles.section}>
      <div className={styles.background}>
        <div className={styles.glowPrimary} />
        <div className={styles.glowAccent} />
      </div>

      <div className={styles.container}>
        <div className={styles.grid}>
          {/*Left content */}
          <div>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
            >
              <div className={styles.badge}>
                <Sparkles className={styles.badgeIcon} />
                <span className={styles.badgeText}>BETA - EARLY ACCESS</span>
              </div>

              <h1 className={styles.title}>
                Genotype-to-Phenotype Reasoning Agent for{" "}
                <span className={styles.titleHighlight}>Mitochondrial</span>{" "}
                Disease
              </h1>

              <p className={styles.description}>
                MitoAgent reasons from genetic variants through molecular
                mechanisms to clinical phenotype — retrieving literature,
                querying structured databases, forming ranked hypotheses, and
                returning a confidence-labelled brief ready for clinical or
                research use.
              </p>

              <div className={styles.buttons}>
                <Link to="/playground">
                  <Button size="lg" className={styles.primaryButton}>
                    Join Beta
                    <ArrowRight className={styles.buttonIcon} />
                  </Button>
                </Link>
                {/* <Link to="/docs">
                  <Button
                    size="lg"
                    variant="outline"
                    className={styles.outlineButton}
                  >
                    Read the docs
                  </Button>
                </Link>*/}
              </div>

              {/* <div className={styles.stats}>
                {[
                  { value: "2.4M+", label: "Papers Trained" },
                  { value: "50k+", label: "Pathways Mapped" },
                  { value: "99.2%", label: "Accuracy" },
                ].map((stat) => (
                  <div key={stat.label} className={styles.statItem}>
                    <div className={styles.statValue}>{stat.value}</div>
                    <div className={styles.statLabel}>{stat.label}</div>
                  </div>
                ))}
              </div>*/}
            </motion.div>
          </div>
          {/* Right Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className={styles.imageWrapper}
          >
            <div className={styles.imageInner}>
              <div className={styles.imageGlow} />
              <img
                src={HERO_IMAGE}
                alt="Mitochondria visualization"
                className={styles.image}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
